<template>
  <!-- No countdown means the user must answer, so block the rest of the UI -->
  <div v-if="timeoutMs <= 0" class="modal-backdrop fade show"></div>
  <div class="confirmation-toast" :class="`confirmation-toast--${position}`" role="alertdialog">
    <p v-if="i18nTitle" class="confirmation-toast__title">{{ $t(i18nTitle) }}</p>
    <p class="confirmation-toast__description">
      {{ $t(i18nDescription, i18nDescriptionParams) }}
    </p>
    <div class="confirmation-toast__actions">
      <button class="btn btn-sm btn-success text-capitalize" type="button" @click="confirmHandler">
        {{ $t(i18nAcceptLabel) }}
      </button>
      <button class="btn btn-sm btn-secondary text-capitalize" type="button" @click="closeHandler">
        {{ $t(i18nDeclineLabel) }}
      </button>
    </div>
    <!-- Countdown to the automatic decline -->
    <div v-if="timeoutMs > 0" class="confirmation-toast__timer">
      <div
        class="confirmation-toast__timer-bar"
        :style="{ animationDuration: `${timeoutMs}ms` }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ScreenPosition } from '@/common/types';

const DEFAULT_TIMEOUT_MS = 5000;

export default defineComponent({
  name: 'ConfirmationToast',
  props: {
    i18nAcceptLabel: {
      type: String,
      default: 'yes'
    },
    i18nDeclineLabel: {
      type: String,
      default: 'no'
    },
    i18nDescription: {
      type: String,
      required: true
    },
    i18nDescriptionParams: {
      type: Object as PropType<Record<string, unknown>>,
      default: () => ({})
    },
    i18nTitle: {
      type: String,
      default: ''
    },
    position: {
      type: String as PropType<ScreenPosition>,
      default: ScreenPosition.BottomRight
    },
    // Time before the toast declines on its own. 0 keeps it open indefinitely.
    timeoutMs: {
      type: Number,
      default: DEFAULT_TIMEOUT_MS
    }
  },
  emits: ['close'],
  data() {
    return {
      timer: null as number | null
    };
  },
  mounted() {
    if (this.timeoutMs <= 0) return;

    this.timer = window.setTimeout(() => this.$emit('close', false), this.timeoutMs);
  },
  beforeUnmount() {
    if (this.timer !== null) clearTimeout(this.timer);
  },
  methods: {
    closeHandler(): void {
      this.$emit('close', false);
    },
    confirmHandler(): void {
      this.$emit('close', true);
    }
  }
});
</script>

<style lang="scss" scoped src="./confirmation-toast.component.scss" />